import { Routes } from '@angular/router';
import { AuthGuard, OnboardingCompleteGuard } from 'svnxii-modules/auth/guards';
import { CRM_NAV_ITEMS } from 'svnxii-modules/crm/nav';
import { FINANCE_NAV_ITEMS } from 'svnxii-modules/finance/nav';
import { INSTALLMENT_NAV_ITEMS } from 'svnxii-modules/installment/nav';
import { INVENTORY_NAV_ITEMS } from 'svnxii-modules/inventory/nav';
import { LOGISTICS_NAV_ITEMS } from 'svnxii-modules/logistics/nav';
import { MAINTENANCE_NAV_ITEMS } from 'svnxii-modules/maintenance/nav';
import { ORGANIZATION_NAV_ITEMS } from 'svnxii-modules/organization/nav';
import { PROCUREMENT_NAV_ITEMS } from 'svnxii-modules/procurment/nav';
import { SALES_NAV_ITEMS } from 'svnxii-modules/sales/nav';
import { HQ_NAV_ITEMS } from 'svnxii-modules/HQ/nav';
import { moduleGuard } from './guards/module.guard';
import { OnboardingGuard } from './guards/onboarding.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'login',
    // TODO: Add Guard prevent open login page if already signed in.
    loadComponent: () => import('svnxii-modules/auth/login').then((m) => m.Login),
  },
  {
    path: 'reset-password/:userId/:email/:token',
    // TODO: Add Guard prevent open reset password page if already signed in.
    loadComponent: () =>
      import('svnxii-modules/organization/features/reset-password').then(
        (m) => m.ResetPassword,
      ),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard, OnboardingGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('svnxii-modules/organization/features/init-department').then(
            (m) => m.Onboarding,
          ),
      },
      {
        path: 'init-company',
        children: [
          {
            path: '',
            redirectTo: 'company-info',
            pathMatch: 'full',
          },
          {
            path: ':step',
            loadComponent: () =>
              import('svnxii-modules/organization/features').then((m) => m.InitCompany),
          },
        ],
      },
    ],
  },
  {
    path: 'app',
    canActivate: [AuthGuard, OnboardingCompleteGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home-page/home-page').then((m) => m.HomePage),
      },
      {
        path: 'crm',
        canActivate: [moduleGuard('crm')],
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/crm/layout').then((m) => m.LAYOUT_ROUTES);
        },
        data: { navItems: CRM_NAV_ITEMS },
      },
      {
        path: 'organization',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/organization/layout').then(
            (m) => m.LAYOUT_ROUTES,
          );
        },
        data: { navItems: ORGANIZATION_NAV_ITEMS },
      },
      {
        path: 'maintenance',
        canActivate: [moduleGuard('maintenance')],
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/maintenance/layout').then((m) => m.LAYOUT_ROUTES);
        },
        data: { navItems: MAINTENANCE_NAV_ITEMS },
      },
      {
        path: 'finance',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/finance/layout').then((m) => m.LAYOUT_ROUTES);
        },
        data: { navItems: FINANCE_NAV_ITEMS },
      },
      {
        path: 'inventory',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/inventory/layout').then((m) => m.LAYOUT_ROUTES);
        },
        data: { navItems: INVENTORY_NAV_ITEMS },
      },
      {
        path: 'sales',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () => {
          return import('svnxii-modules/sales/layout').then((m) => m.LAYOUT_ROUTES);
        },
        data: { navItems: SALES_NAV_ITEMS },
      },

      {
        path: 'procurement',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () =>
          import('svnxii-modules/procurment/layout').then((m) => m.LAYOUT_ROUTES),
        data: { navItems: PROCUREMENT_NAV_ITEMS },
      },

      {
        path: 'installment',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () =>
          import('svnxii-modules/installment/layout').then((m) => m.LAYOUT_ROUTES),
        data: { navItems: INSTALLMENT_NAV_ITEMS },
      },

      {
        path: 'organization',
        loadComponent: () =>
          import('svnxii-modules/organization/layout').then((m) => m.Layout),
        loadChildren: () =>
          import('svnxii-modules/organization/layout').then((m) => m.LAYOUT_ROUTES),
      },
      {
        path: 'logistics',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () =>
          import('svnxii-modules/logistics/layout').then((m) => m.LAYOUT_ROUTES),
        data: { navItems: LOGISTICS_NAV_ITEMS },
      },
      {
        path: 'hq',
        loadComponent: () => import('svnxii-ng-shared/components').then((m) => m.Layout),
        loadChildren: () =>
          import('svnxii-modules/HQ/layout').then((m) => m.LAYOUT_ROUTES),
        data: { navItems: HQ_NAV_ITEMS },
      },
    ],
  },
  {
    path: 'logistics',
    loadComponent: () => import('svnxii-modules/logistics/layout').then((m) => m.Layout),
    loadChildren: () =>
      import('svnxii-modules/logistics/layout').then((m) => m.LAYOUT_ROUTES),
    canActivate: [AuthGuard],
  },
];
